const SITE_NAME = 'RetroPlay';

export function normalizePageTitle(value) {
  return String(value || '').replace(/\u2014/g, '-');
}

export function formatPageTitle(label) {
  const value = normalizePageTitle(label).trim();
  return value ? `${value} - ${SITE_NAME}` : SITE_NAME;
}

export function setPageTitle(label) {
  const title = formatPageTitle(label);
  document.title = title;
  return title;
}
